import React from "react"
import {Button, Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2"
import {DateTime} from "luxon";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import ReservationActions from "../../Redux/reservationRedux";
import {RootState} from "../../Redux";
import api from "../../Services/api";
import BackButton from "./Common/BackButton";
import {ServiceCardType} from "./Types";
import {getLocale, numberToCurrencyString} from '../../Utils/helpers'

const { getCheckIn } = api.create()

interface ReservationReadyProps {
    registrationNumber: string
    date: DateTime
    serviceType: string
    handleToPayment: (action: string) => void
    setServiceCard: (serviceCard: ServiceCardType) => void
    serviceCard?: ServiceCardType
    onBack: () => void
}

const ReservationReady = ({registrationNumber, date, serviceType, handleToPayment, setServiceCard, serviceCard, onBack}: ReservationReadyProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const locale = getLocale()

    const {
        reservation,
    }: any = useSelector(
        ({ reservation }: RootState): any => ({
            reservation: reservation.reservation,
        }),
    )

    const customerInfo = useSelector((state: RootState) => state.ui.customer)

    const handleReservation = (paymentType: string | null) => {
        const token = reservation?.token
        const callbacks = [
            async () => {
                const response = await getCheckIn(token)
                if (response.ok) {
                    setServiceCard(response.data as ServiceCardType)
                }
                handleToPayment(paymentType)
            }
        ]
        if (reservation?.token) {
            dispatch(ReservationActions.postFinalReservation(customerInfo?.token, callbacks))
        } else {
            handleToPayment(paymentType)
        }
    }

    return (<>
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid>
            </Grid>
            <Grid style={{textAlign: 'center'}}>
                <Typography variant="h4" gutterBottom>{t('selfService.newReservation')}</Typography>
                <Typography variant="h1" className="registrationNumber">{registrationNumber}</Typography>
                <Typography variant="subtitle1">{serviceType}</Typography>
                <Typography variant="subtitle1" gutterBottom>
                    {date.toFormat(`cccc dd.MM.yyyy '${t('common.time_of_day')}' HH:mm`, {locale})}
                </Typography>
            </Grid>
            <Grid className="footerButtons">
                <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                    {reservation?.token ? <BackButton onBack={onBack} /> : <div></div>}
                    <Stack direction="row" spacing={8} alignItems="end">
                        <div>
                            <div style={{textAlign: 'center'}}>
                                <Typography variant="subtitle1" gutterBottom>{numberToCurrencyString(reservation?.prices?.online?.value ?? reservation?.prices?.normal?.value) }</Typography>
                            </div>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="buttonNarrow"
                                onClick={() => handleReservation(null)}
                            >
                                {t('selfService.reserve')}
                            </Button>
                        </div>
                        <div>
                            <div style={{textAlign: 'center'}}>
                                <Typography variant="subtitle1" gutterBottom>Varaa ja maksa ennakkoon {numberToCurrencyString(reservation?.prices?.prepaid?.value ?? reservation?.prices?.online?.value ?? reservation?.prices?.normal?.value) }</Typography>
                            </div>
                            <Stack direction="row" spacing={2}>
                                <Button
                                    disabled={customerInfo?.isInvoicingEnabled || reservation?.prices?.normal?.value === 0}
                                    variant="contained"
                                    color="secondary"
                                    className="buttonNarrow"
                                    onClick={() => handleReservation('payWithCard')}
                                >
                                    {t('selfService.payWithCard')}
                                </Button>
                                <Button
                                    disabled={customerInfo?.isInvoicingEnabled || reservation?.prices?.normal?.value === 0}
                                    variant="contained"
                                    color="secondary"
                                    className="buttonNarrow"
                                    onClick={() => handleReservation('payOnline')}
                                >
                                    {t('selfService.payOnline')}
                                </Button>
                            </Stack>
                        </div>
                    </Stack>
                </Grid>
            </Grid>
        </Grid>
    </>)
}

export default ReservationReady
